import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { QuestionCard } from "../common";

const questionOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const Question5 = ({
  updateQuestion,
  jurisdiction,
  answer,
  updateAnswer,
}) => {
  const [selection, setSelection] = useState(answer || "");
  const navigate = useNavigate();

  const handleSelectionChange = (value) => {
    setSelection(value);
    updateAnswer(value);
    sessionStorage.setItem("answer_q5", value);
  };

  const isNextDisabled = selection === "" || !answer;

  const handleNext = () => {
    if (selection === "no") {
      const contentKey =
        jurisdiction === "parliamentary"
          ? "q5_not_complained_parliamentary"
          : "q5_not_complained_nhs";
      navigate("/cannot-help", { state: { contentKey } });
    } else {
      updateQuestion(6);
    }
  };

  return (
    <QuestionCard
      question="Have you complained directly to the organisation?"
      options={questionOptions}
      required={true}
      selectedValue={selection}
      onChange={handleSelectionChange}
      onPrevious={() =>
        jurisdiction === "nhs" ? updateQuestion(4) : updateQuestion(2)
      }
      onNext={handleNext}
      showPrevious={true}
      nextDisabled={isNextDisabled}
      name="complained-directly"
    />
  );
};

Question5.propTypes = {
  updateQuestion: PropTypes.func,
  jurisdiction: PropTypes.string,
  answer: PropTypes.string,
  updateAnswer: PropTypes.func,
};
